import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';

const styles = theme => ({
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
  },
});

const KobooTextField = ({
  label,
  id,
  onChange,
  value,
  classes,
  md,
  disabled,
  type,
  variant,
  width,
  required
}) =>
  <Grid item xs={12} sm={12} md={md ? md : 4}>
    <TextField
      className={classes.textField}
      label={label}
      id={id}
      type={type ? type : "text"}
      onChange={onChange}
      margin="normal"
      value={value}
      required={required}
      disabled={disabled || false}
      variant={variant || "standard"}
      style={{ width: width ? width : 200}}
    />
  </Grid>;

export default withStyles(styles)(KobooTextField);



// WEBPACK FOOTER //
// ./src/components/Layout/KobooTextField.jsx